<template>
    <v-app white>

        <v-navigation-drawer v-if="me"
                             temporary
                             :right="false"
                             v-model="show"
                             fixed
                             app
        >
            <v-parallax src="img/drawer.jpeg" height="100">
                <v-list class="pa-0">
                    <v-list-tile avatar>
                        <v-list-tile-avatar>
                            <v-avatar color="white">
                                <v-icon  >account_circle</v-icon>
                            </v-avatar>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title class="white--text">{{me.nome}}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-parallax>

            <v-list class="pt-0" dense>

                <v-divider/>

                <v-list-tile @click="goTo('/')">
                    <v-list-tile-action>
                        <v-icon>home</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>
                        Início
                    </v-list-tile-title>
                </v-list-tile>

                <v-divider/>

                <v-list-tile @click="goTo('/list-ordens')">
                    <v-list-tile-action>
                        <v-icon>compare_arrows</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>
                        Minhas Ordens
                    </v-list-tile-title>
                </v-list-tile>

                <v-divider/>

                <v-list-group
                        no-action
                        sub-group
                        v-model="caixa"
                        value="true"
                >
                    <v-list-tile slot="activator">
                        <v-list-tile-title>Caixas</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile @click="goTo('/list-ctos')">
                        <v-list-tile-title>
                            Listar Caixas CTO
                        </v-list-tile-title>
                    </v-list-tile>

                    <v-divider/>

                    <v-list-tile @click="goTo('/ver-caixas-maps')">
                        <v-list-tile-title>
                            Caixas no Mapa
                        </v-list-tile-title>
                    </v-list-tile>

                    <v-divider/>

                    <v-list-tile @click="goTo('/problemas/sinal')">
                        <v-list-tile-title>
                            Caixas com Problemas
                        </v-list-tile-title>
                    </v-list-tile>

                    <v-divider/>

                    <v-list-tile @click="goTo('/caixas/offline')">
                        <v-list-tile-title>
                            Caixas Offline
                        </v-list-tile-title>
                    </v-list-tile>

                    <v-divider/>

                    <v-list-tile @click="goTo('/cadastrar/caixa')">
                        <v-list-tile-title>
                            Cadastrar PAC-PON
                        </v-list-tile-title>
                    </v-list-tile>

                    <v-divider/>

                    <v-list-tile @click="goTo('/substituir/caixa')">
                        <v-list-tile-title>
                            Substituir PAC-PON
                        </v-list-tile-title>
                    </v-list-tile>

                </v-list-group>

                <v-divider/>

                <v-list-group
                        no-action
                        sub-group
                        v-model="onu"
                        value="true"
                >
                    <v-list-tile slot="activator">
                        <v-list-tile-title>ONUS</v-list-tile-title>
                    </v-list-tile>

                    <v-divider/>

                    <v-list-tile @click="goTo('/onus-unregistered')">
                        <v-list-tile-title>
                            Onus Não Registradas
                        </v-list-tile-title>
                    </v-list-tile>

                </v-list-group>

                <v-divider/>

                <v-list-tile @click="bye()">
                    <v-list-tile-action>
                        <v-icon>exit_to_app</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>
                        Sair
                    </v-list-tile-title>
                </v-list-tile>

                <v-divider/>

            </v-list>
        </v-navigation-drawer>

        <v-content>
            <router-view/>
        </v-content>

    </v-app>
</template>

<script>
    import { EventBus } from "./utils/event-bus";
    import Menu from "./components/menu/Start.vue";
    import { Me } from "./class/me";
    import { Ordens } from "./class/ordens";

    export default {
        components: {
            Menu
        },
        data () {
            return {
                caixa: false,
                onu: false,
                fixed: false,
                show: false,
                me: null
            };
        },
        beforeMount () {
            EventBus
                .$on("drawer", async () => {
                    if (!this.me) {
                        await this.getMe();
                    }
                    this.show = !this.show;
                });

            EventBus.$on("login", async () => this.getMe());
            this.getMe();
        },
        name: "App",
        methods: {
            getMe: async function () {
                try {
                    this.me = await Me.get();
                } catch (e) {
                    console.error(e);
                }
            },
            goTo: function (url) {
                this.$router.push(url);
            },
            bye: async function () {
                try {
                    await Me.clear();
                    await Ordens.clear();
                    this.me = null;
                    this.$router.push("/login");
                } catch (err) {
                    console.error(err);
                    alert("Problemas para sair");
                }
            }
        }
    };
</script>
